







































































import { Component, Vue, Inject, Prop } from 'vue-property-decorator';
import { CrudService } from '@/data/services/crud.service';
import { Tipologiaintervento } from '@/data/models/tipologiaintervento.model';
import { Search, SortDirection } from '@/data/models/search.model';

@Component
export default class TipologiainterventoList extends Vue {
	@Prop({ default: true }) editable!: boolean;
	@Prop({ default: false }) checkboxable!: boolean;
	@Prop({ default: () => [] }) selected!: Tipologiaintervento[];
	
	@Inject('CrudService') crudService!: CrudService<Tipologiaintervento>;

	rows: Tipologiaintervento[] = [];
	loading: boolean = false;
	advancedSearch: Search = new Search('intervento');
	checkedRows: Tipologiaintervento[] = [];

	constructor() {
		super();
		this.advancedSearch.setSortDirection(SortDirection.ASCENDING);
		this.advancedSearch.setSortField('id');
	}

	loadTipologieintervento() {

		const datareq = this.crudService.searchEntities(
			Tipologiaintervento,
			'intervento',
			this.advancedSearch,
			this.advancedSearch.page
		);
		const countreq = this.crudService.countEntities(
			Tipologiaintervento,
			'intervento',
			this.advancedSearch
		);

		this.loading = true;
		Promise.all([datareq, countreq])
			.then((results) => {
				this.rows = results[0];
				this.advancedSearch.page.setTotal(results[1].ct);
			})
			.catch(({ data }) => {
				this.$buefy.notification.open({
					message: data.msg || data.internal,
					type: 'is-danger',
				});
			})
			.finally(() => (this.loading = false));
	}

	editTipologiaintervento(item: Tipologiaintervento) {
		this.$emit('edit', item);
	}

	openTipologiaintervento(item: Tipologiaintervento) {
		this.$emit('open', item);
	}

	deleteTipologiaintervento(item: Tipologiaintervento) {
		this.$emit('delete', item);
	}

	onPageChange(page: number) {
		this.advancedSearch.page.setPageNumber(page - 1);
		this.loadTipologieintervento();
	}

	onSortChange(field: string, dir: string) {
		this.advancedSearch.setSortField(field);
		this.advancedSearch.setSortDirection(dir);
		this.loadTipologieintervento();
	}

}
